import React, { useState, useEffect } from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Icons
import CloseIcon from '../../../../icons/close.svg';

// Styles
import styles from './Notification.styl';

const cx = classNames.bind(styles);

export default function Notification(props) {
  const { isOpen, children } = props;

  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const onClose = () => {
    setIsNotificationOpen(false);
  };

  useEffect(() => {
    setIsNotificationOpen(isOpen);
  }, [isOpen]);

  return (
    <Transition
      in={isNotificationOpen}
      timeout={{ enter: 0, exit: 175 }}
      mountOnEnter
      unmountOnExit
    >
      {transitionState => (
        <div className={cx('Notification', `Notification_${transitionState}`)}>
          {children}
          <button className={cx('Notification__close')} onClick={onClose} type="button">
            <CloseIcon />
          </button>
        </div>
      )}
    </Transition>
  );
}

Notification.propTypes = {
  children: PropTypes.any.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
